"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/// <reference types="jquery"/>
var vue_1 = __importDefault(require("vue"));
var TextOutput_vue_1 = __importDefault(require("../Output/TextOutput.vue"));
var CheckBox_vue_1 = __importDefault(require("../Input/CheckBox.vue"));
var SelectCustom_vue_1 = __importDefault(require("../Input/SelectCustom.vue"));
var Row_vue_1 = __importDefault(require("../Layout/Row.vue"));
var Column_vue_1 = __importDefault(require("../Layout/Column.vue"));
var ControlIteration_1 = __importDefault(require("../../Mixins/ControlIteration"));
exports.default = vue_1.default.extend({
    props: ["name", "index", "datas"],
    mixins: [ControlIteration_1.default],
    components: { TextOutput: TextOutput_vue_1.default, CheckBox: CheckBox_vue_1.default, SelectCustom: SelectCustom_vue_1.default, HeRow: Row_vue_1.default, HeColumn: Column_vue_1.default },
    data: function () {
        var data = !this.datas || this.datas === {} ? "" : this.datas;
        return {
            isCommande: data.isCommande || false,
            puissance: data.puissance || (this.datas === null ? "puissance" : ""),
            tpc: data.tpc || false,
            type: data.type || (this.datas === null ? "type" : ""),
            numPoste: data.numPoste || "",
            nomPoste: data.nomPoste || "",
            besoinId: data.besoinId || "",
            entrepriseId: data.entrepriseId || [],
            filter: data.filter || true
        };
    },
    methods: {
        getParameters: function () {
            return "" + this.getPrefixedName('type') +
                ("," + this.getPrefixedName('puissance')) +
                ("," + this.getPrefixedName('tpc')) +
                ("," + this.getPrefixedName('filter') + "|" + this.getPrefixedName('idEntreprise'));
        },
        setIsCommande: function (isCmd) {
            this.isCommande = isCmd;
        },
        getGestionTransfoValue: function () {
            var self = this, id = this.$root.$data.data
                ? this.$root.$data.data[this.prefixIt]
                    ? this.$root.$data.data[this.prefixIt][this.index]
                        ? this.$root.$data.data[this.prefixIt][this.index].gestionTransfoId
                        : 0
                    : 0
                : 0;
            if (id && id > 0) {
                $.ajax({
                    url: '/Affaires/GetGestionTransfo',
                    type: 'get',
                    data: {
                        id: id
                    },
                }).done(function (data) {
                    self.$refs.select.value = data;
                });
            }
            return "";
        }
    },
    mounted: function () {
        var self = this;
        this.$watch(function () {
            return self.$refs.chkbcmd.value;
        }, function (newval, oldval) {
            self.setIsCommande(newval);
        });
        if (this.$refs.chkbfilter) {
            this.$watch(function () {
                return self.$refs.chkbfilter.value;
            }, function (newval, oldval) {
                var selectCompo = self.$refs.select;
                selectCompo.items = [];
                selectCompo.getOptions();
            });
        }
        this.getGestionTransfoValue();
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./_wwwsrc/js/Workflow/Components/SpecificComponents/AffectationTransformateur.vue
// module id = 203
// module chunks = 0